module.exports = __webpack_public_path__ + "img/release_risk_bg3.bc86b3af.jpg";